<!-- 子组件 child.vue -->

<template>
  <div class="login-mod">
    <div v-if="!ShowUser">
      <div class="login-dl">会员登录</div>
      <div class="login-dlbg"></div>
      <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" style="padding-top:50px;padding-right: 0px !important;">
          <!-- <el-form-item label="类型：">
            <el-select v-model="form.type" placeholder="" style="width: 185px;">
              <el-option v-for="item in Arr" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="会员名：" prop="name">
            <el-input placeholder="请输入会员名" v-model="form.name" style="width: 185px;"></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="pass">
            <el-input placeholder="请输入密码" type="password" v-model="form.pass" style="width: 185px;"></el-input>
          </el-form-item>    
        </el-form>        
        <button class="login-btdl" @click="login">登录</button>
        <button class="login-btzc"><router-link :to="{ name: 'Register' }">注册</router-link></button>
      </div>
    </div>
    <div v-else>
      <div style="text-align: center;padding: 80px 0px;font-size: 20px;" >
        {{ username }},<font style="color: #ff0000;">欢迎您</font>      
      </div>
      <router-link class="login-btdl" style="background: #ff0000;padding: 10px" to="/Xieyi">会员中心</router-link>      
      <button class="login-btzc" @click="loginOut" >安全退出</button> 
    </div>
  </div>
</template>
<script>
import applicationUserManager from "../Auth/applicationusermanager";
export default {
  data: function () {
    return {
      username: '',
      form: {
        name: "",
        pass: ""
      },
      rules: {
        name: [{ required: true, message: "会员名不能为空", trigger: "blur" }],
        pass: [{ required: true, message: "密码不能为空", trigger: "blur" }]
      },
      ShowUser: false
    };
  },
  props: {
    formData: Object
  },
  methods: {
    login() {
      let that = this;
      that.$store.commit("saveToken", "");
      that.$refs.form.validate(valid => {
        if (valid) {
          that.$api.post(
            "Login/Token3.0",{ name: that.form.name, pass: that.form.pass },data => {          
              if (data.success) {
                var token = data.response.token;
                that.$store.commit("saveToken", token);
                window.localStorage.setItem("USER_NAME", that.form.name);
                var curTime = new Date();
                var expiredate = new Date(curTime.setSeconds(curTime.getSeconds() + data.response.expires_in));
                that.$store.commit("saveTokenExpire", expiredate);
                window.localStorage.refreshtime = expiredate;
                window.localStorage.expires_in = data.response.expires_in;
                that.$notify({
                  type: "success",
                  message: "欢迎您," + that.form.name + "!",
                  duration: 3000
                });
                //_this.getUserInfoByToken(token)
                that.$router.replace("/Xieyi");
              } else {
                that.$message({
                  type: "error",
                  message: "用户名或密码错误",
                  showClose: true
                });
              }
            });
        } else {
          return false;
        }
      });
    },
    loginOut(){
        this.$store.commit("saveToken", "");
        window.localStorage.removeItem("USER_NAME");
         window.location.href = '/';        
    }    
  },
  created() {
    if(this.$store.state.token != 'undefined' && this.$store.state.token)
    {
      this.ShowUser = true;
      this.username = window.localStorage.getItem("USER_NAME")
    }
    var curTime = new Date();
    var refreshtime = window.localStorage.getItem("refreshtime")    
    if(refreshtime)
    {
      var expiredate = new Date(refreshtime);
      if(curTime > expiredate){
        this.ShowUser = false;
      }
    }else{
      this.ShowUser = false;
    }
  },
  watch: {
    // 因为不能直接修改 props 里的属性，所以不能直接把 formData 通过v-model进行绑定
    // 在这里我们需要监听 formData，当它发生变化时，立即将值赋给 data 里的 form
    formData: {
      immediate: true,
      handler(val) {
        this.form = val;
      }
    }
  },
};
</script>
<style lang="stylus" scoped>
.el-form {
  .el-form-item {
    /deep/ * {
      font-size: 18px;
      color: #222222;
    }
  }
}

</style>
